<template>
  <div class="container">
    <div class="alert alert-info" role="alert">
      <span>Comunicando com gov.br para validar a autenticação.</span>
    </div>
    <div id="carregando" class="loader"></div>
  </div>
</template>
<script>
import UiConfig from '../../config/ui'
import bus from '../../bus.js'

const href = window.location.href
if (href.indexOf('loginunicocallback') > -1 && href.indexOf('#') > href.indexOf('?')) {
  location.replace(getUrl('/loginunicocallback'))
}

function getUrl (path) {
  const href = window.location.href
  const hashPos = href.indexOf('#')
  let base = hashPos > -1 ? href.slice(0, hashPos) : href

  const searchPos = base.indexOf('?')
  const query = searchPos > -1 ? base.slice(searchPos) : ''
  base = query ? base.slice(0, searchPos) : base

  return `${base}#${path + query}`
}
export default {
  mounted () {
    if (this.$route.query.error !== undefined && this.$route.query.error === 'access_denied') {
      bus.emit('siop-limpa-tudo')
      bus.emit('siop-erro', 'Uso da autenticação gov.br não autorizada pelo usuário.')
      this.$router.push('paginainicial')
    } else {
      const href = window.location.href
      if (href.indexOf('loginunicocallback') > -1 && href.indexOf('#') > href.indexOf('?')) {
        location.replace(getUrl('/loginunicocallback'))
        return
      }
      if (this.$route.query.code !== undefined && this.$route.query.state !== undefined) {
        this.encaminhaRequisicaoLoginServico()
      } else {
        bus.emit('siop-limpa-tudo')
        bus.emit('siop-erro', 'Falha ao solicitar autenticação com gov.br')
        this.$router.push('paginainicial')
      }
    }
  },
  methods: {
    async encaminhaRequisicaoLoginServico () {
      try {
        const url = UiConfig.urls.auth.loginUnicoCallback + '?code=' + this.$route.query.code + '&state=' + this.$route.query.state
        const response = await fetch(url)

        if (!response.ok) {
          const data = await response.json().catch(() => ({}))
          const mensagens = {
            404: 'Serviço de autenticação não encontrado',
            400: data.err || 'Falha ao solicitar autenticação com gov.br',
            401: data.err || 'Falha ao solicitar autenticação com gov.br'
          }
          throw new Error(mensagens[response.status] || 'Falha ao solicitar autenticação com gov.br')
        }

        const data = await response.json()
        window.localStorage.setItem('token', data.tokenSiop)
        window.localStorage.setItem('refreshToken', data.refreshToken)
        document.location = UiConfig.paths.default
      } catch (err) {
        bus.emit('siop-limpa-tudo')
        bus.emit('siop-erro', err.message || 'Falha ao solicitar autenticação com gov.br')
        this.$router.push('paginainicial')
      }
    }
  }
}
</script>
<style scoped>
.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: 75px 0 0 -75px;
  border: 10px solid #3498db;
  border-radius: 50%;
  border-top: 10px solid #b2d2ff;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 0.75s linear infinite;
  animation: spin 0.75s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
